// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3ZGwk","disabled":"FileBtn_disabled__2gNQL","warn":"FileBtn_warn__2n7L8","fade":"FileBtn_fade__3upH6"};